var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCompliance(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.00314 0C8.14689 0 8.29064 0.03125 8.41876 0.090625L14.3063 2.5875C14.9938 2.87813 15.5063 3.55625 15.5031 4.375C15.4875 7.475 14.2125 13.1469 8.82814 15.725C8.30626 15.975 7.70001 15.975 7.17814 15.725C1.79064 13.1469 0.515639 7.47813 0.500014 4.375C0.496889 3.55625 1.00939 2.87813 1.69689 2.5875L7.58439 0.090625C7.71251 0.03125 7.85626 0 8.00314 0ZM2.28439 3.96875C2.10001 4.04688 2.00001 4.20937 2.00314 4.36562C2.01876 7.22188 3.20314 12.1562 7.82814 14.3687C7.94064 14.4219 8.07189 14.4219 8.18126 14.3687C12.8063 12.1562 13.9906 7.22188 14.0031 4.36562C14.0031 4.20937 13.9063 4.04688 13.7219 3.96875L8.00314 1.54375L2.28439 3.96875ZM9.79376 5.05937C10.0375 4.725 10.5063 4.65 10.8406 4.89375C11.175 5.1375 11.25 5.60625 11.0063 5.94063L7.80626 10.3406C7.67501 10.5188 7.47189 10.6313 7.25001 10.6469C7.02814 10.6625 6.81251 10.5781 6.65939 10.4187L5.20939 8.91875C4.92189 8.62187 4.92814 8.14688 5.22814 7.85938C5.52501 7.57188 6.00001 7.58125 6.28751 7.87813L7.11564 8.73438L9.79064 5.05625L9.79376 5.05937Z",
    fill: "#B88333"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCompliance);
export default __webpack_public_path__ + "static/media/compliance.ca70093c69a9cfeaba942256c826dc9a.svg";
export { ForwardRef as ReactComponent };